<template>
    <app-main>
        <app-content>

            <div class="flex flex-wrap -mx-2">
                <div class="w-full md:w-1/2 px-2">
                    <!-- Start Title -->
                    <app-title
                        title="Services"
                        sub-title="Viewing service drafts"
                    />
                    <!-- End Title -->
                </div>
                <div class="w-full md:w-1/2 px-2 md:text-right">
                    <app-button v-if="service" element="a" class="btn  btn--secondary  btn--secondary--sml ml-4" @click="$router.push({ name: 'services.home' })">
                        Cancel
                    </app-button>
                </div>
            </div>

            <app-box :loading="loading" :initial="loading">
                <app-table v-if="service && service.drafts.length > 0 && checkPermission('services', 'publishable')">
                    <app-table-header>
                        <app-table-row :header="true">
                            <app-table-cell :header="true">
                                Title
                            </app-table-cell>
                            <app-table-cell class="text-center" :header="true">
                                Languages
                            </app-table-cell>
                            <app-table-cell class="text-center" :header="true" />
                        </app-table-row>
                    </app-table-header>

                    <app-table-body>
                        <app-table-row v-for="(d, i) in service.drafts" :key="i">
                            <app-table-cell>
                                {{ d.title }}
                            </app-table-cell>
                            <app-table-cell class="text-center">
                                <div v-for="(locale, key) in locales" :key="key" v-tooltip="locale.lang" class="inline-block mr-3">
                                    <span v-if="d.locale.flag != locale.flag">
                                        <img :src="require(`../../../assets/img/flags/${locale.flag}.png`)" style="width: 30px; height: 18px;" class="rounded-lg opacity-25"  />
                                    </span>
                                    <span v-else>
                                        <img :src="require(`../../../assets/img/flags/${locale.flag}.png`)" class="rounded-lg" style="width: 30px; height: 18px;"  />
                                    </span>
                                </div>
                            </app-table-cell>
                            <app-table-cell>
                                <router-link :to="{ name: 'services.view', params: { id: d.id } }" class="mr-2 text-blue hover:text-blue-darker" v-if="checkPermission('services', 'edit')">
                                    <app-icon icon="eye" />
                                </router-link>
                                <app-icon icon="trash" class="text-red cursor-pointer" @click="confirmModalOpened = true; confirmModalId = d.id" v-if="checkPermission('services', 'delete')" />
                            </app-table-cell>
                        </app-table-row>
                    </app-table-body>
                </app-table>
            </app-box>
        </app-content>

        <app-confirm-modal
            v-if="confirmModalOpened"
            @confirm="remove"
            @close="confirmModalOpened = false; confirmModalId = false"
            actionText="Yes please"
            cancelText="No thanks"
            heading="Hang on!"
            text="You are about to delete a service draft. Are you sure you wish to continue?"
        />
    </app-main>
</template>

<script>
    import { mapGetters } from 'vuex';
    /* API */
    import Api from '@/api/index.js';
    import Auth from '@/api/auth.js';
    /* Components */
    import Main from '@/components/Main';
    import Content from '@/components/template/Content';
    import Title from '@/components/Title';
    import Box from '@/components/Box';
    import Button from '@/components/Button';
    import PaginationLinks from '@/components/PaginationLinks';
    import ConfirmModal from '@/components/modals/ConfirmModal';

    /* Mixins */
    import Permissions from '@/mixins/permissions';

    export default {
        name: 'articles.drafts.home',

        data: () => ({
            loading: false,
            service: null,
            response: null,
            confirmModalOpened: false,
            confirmModalId: false,
        }),

        components: {
            'app-main': Main,
            'app-content': Content,
            'app-title': Title,
            'app-box': Box,
            'app-button': Button,
            'app-pagination-links': PaginationLinks,
            'app-confirm-modal': ConfirmModal
        },

        mixins: [ Permissions ],

        mounted() {
            if (typeof this.$route.params.id != 'undefined') {
                this.loading = true;

                this.getService(this.$route.params.id)
                    .then(response => {
                        this.loading = false;
                    })
                    .catch(error => {
                        this.$router.push({name: 'services.home'});
                    });
            } else {
                this.$router.push({name: 'services.home'});
            }
        },

        computed: {
            ...mapGetters({
                locales: 'locales/items'
            })
        },

        methods: {
            getService(id) {
                return Api.request('get', `services/edit/${id}`)
                    .then(({ data }) => {
                        this.service = data.service;
                        this.response = data;
                    });
            },
            isTranslated(service, locale) {
                let translated = false;

                if (service.children.length > 0 && service.locale.flag != locale.flag) {
                    service.children.forEach(child => {
                        if (child.locale.flag == locale.flag) {
                            translated = true;
                        }
                    });
                }
                
                return translated;
            },
            getId(service, locale) {
                let id = service.id;

                if (service.children.length > 0 && service.locale.flag != locale.flag) {
                    service.children.forEach(child => {
                        if (child.locale.flag == locale.flag) {
                            id = child.id;
                        }
                    });
                }

                return id;
            },
            deleteServices(id) {
                return Api.request('get', `services/delete/${id}`);
            },
            remove() {
                this.confirmModalOpened = false;
                this.loading = true;

                this.deleteServices( this.confirmModalId ).then(response => {
                    return this.getService(this.$route.params.id);
                }).then(response => {
                    this.loading = false;
                    this.confirmModalId = false;
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/services/drafts/Home.vue